import { getPathSeparator } from './helpers';

export interface FileNameTransformOptions {
  keepPath?: boolean;
  removeExt?: boolean;
  validExtFunc?: (ext: string) => boolean;
}

/**
 * Transforms a file into its file name
 * By default, removes the path
 * Can optionally remove the file extension, or only the file extensions that are valid
 *
 * @param {{ name: string; type?: string }} file
 * @param FileNameTransformOptions [args]
 * @returns {string}
 */
export function fileNameTransform(
  file: { name: string; type?: string },
  args?: FileNameTransformOptions
): string {
  let fileName = file.name;
  // remove the path if no arguments are given, or if keepPath is false
  const removePath = !args || !args.keepPath;
  if (removePath) {
    const lastSlash = Math.max(fileName.lastIndexOf(getPathSeparator()));
    if (lastSlash !== -1) {
      fileName = fileName.substring(lastSlash + 1);
    }
  }

  const lastDot = fileName.lastIndexOf('.');
  const fileExt = fileName.split('.').pop();

  // remove the file extension if the option is set and there is dot in the file name
  let removeExt = args && args.removeExt && lastDot !== -1;

  if (removeExt && args.validExtFunc) {
    // if we only remove valid file extensions, check the extension and that the file is of that type
    removeExt = args.validExtFunc(fileExt) && fileExt === file.type;
  }

  if (removeExt) {
    fileName = fileName.substring(0, lastDot);
  }

  return fileName;
}
